module.exports = [
  {
    "id": 1,
    "slug": "loni-baur",
    "title": "Loni Baur"
  },
  {
    "id": 2,
    "slug": "armin-morbach",
    "title": "Armin Morbach"
  },
  {
    "id": 3,
    "slug": "bastian-achard",
    "title": "Bastian Achard"
  },
]
